import { render, staticRenderFns } from "./ToCurrentOrthographiqExercise.vue?vue&type=template&id=1523df21&"
import script from "./ToCurrentOrthographiqExercise.vue?vue&type=script&lang=js&"
export * from "./ToCurrentOrthographiqExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports